// Privacy modes from the URL (server side: api/_privacy.js):
//   isolate=1  no telemetry: no error reports, analytics or hits
//   cookies=0  no device storage: the visitor id comes from the server
//   default    random anonymous visitor id kept in localStorage
const VISITOR_ID = 'vf-vid';
const params = new URLSearchParams(location.search);

export const isIsolateMode = params.get('isolate') === '1';
// false for cookies=0 and isolate=1: nothing may be written to the device
export const allowsDeviceStorage = !isIsolateMode && params.get('cookies') !== '0';
export const visitorId = resolveVisitorId();

function resolveVisitorId(): string | null {
  if (isIsolateMode) {
    return null;
  }
  if (!allowsDeviceStorage) {
    return document.querySelector<HTMLMetaElement>(`meta[name="${VISITOR_ID}"]`)?.content || null;
  }
  try {
    let id = localStorage.getItem(VISITOR_ID);
    if (!id) {
      id = randomId();
      localStorage.setItem(VISITOR_ID, id);
    }
    // the webviewer reads the visitor id from this meta tag
    const meta = document.createElement('meta');
    meta.name = VISITOR_ID;
    meta.content = id;
    document.head.appendChild(meta);
    return id;
  } catch (e) {
    // storage blocked by the browser
    return null;
  }
}

function randomId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
}
